var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bc-slds-nav-vertical__subsection"},[_c('h3',{staticClass:"bc-slds-nav-vertical__subtitle"},[_vm._v(_vm._s(_vm.title))]),_c('ul',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }